import React from 'react'
// import { processSilentRenew } from 'redux-oidc'
import { userManager } from 'auth/userManager'
import { Redirecting } from './redirecting'

const processSilentRenew = () => {
  userManager.signinSilentCallback()
}
const SilentSigninCallbackPage = (props) => {
  processSilentRenew()
  return <Redirecting />
}

export {
  SilentSigninCallbackPage
}
